/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import { ArrowDownTwoIcon, ArrowUpTwoIcon, PriorityFlagIcon } from '@sketchnote/icons';
import Tippy from '@tippyjs/react';
import * as React from 'react';
import {
  components as SelectComponents,
  GroupTypeBase,
  OptionTypeBase,
  SingleValueProps,
  StylesConfig,
} from 'react-select';

import { userSelectStyles } from './user';

export const priorityOptions = [
  {
    label: 'No priority',
    value: '',
    color: '#878A92',
    bgColor: '#ffffff',
  },
  {
    label: 'High',
    value: 'high',
    color: '#C31F09',
    bgColor: '#FCCFCA',
  },
  {
    label: 'Medium',
    value: 'medium',
    color: '#C27300',
    bgColor: '#FFE6BF',
  },
  {
    label: 'Low',
    value: 'low',
    color: '#1D3CAA',
    bgColor: '#D3DBF8',
  },
];

export const PriorityLabels = {
  low: (helpText = 'Low priority') => (
    <Tippy content={helpText}>
      <span style={{ color: priorityOptions[2].color }}>
        <ArrowDownTwoIcon />
      </span>
    </Tippy>
  ),
  medium: (helpText = 'Medium priority') => (
    <Tippy content={helpText}>
      <span style={{ color: priorityOptions[1].color }}>
        <ArrowUpTwoIcon />
      </span>
    </Tippy>
  ),
  high: (helpText = 'High priority') => (
    <Tippy content={helpText}>
      <span style={{ color: priorityOptions[0].color }}>
        <ArrowUpTwoIcon />
      </span>
    </Tippy>
  ),
};

export const PriorityBars = {
  low: (helpText = 'Low priority') => (
    <div className="h-22 w-10 -ml-18 rounded-md bg-green-600"></div>
  ),
  medium: (helpText = 'Medium priority') => (
    <div className="h-22 w-10 -ml-18 rounded-md bg-yellow-700"></div>
  ),
  high: (helpText = 'High priority') => (
    <div className="h-22 w-10 -ml-18 rounded-md bg-red-900"></div>
  ),
};

export const renderPriorities = {
  low: PriorityLabels.low(),
  medium: PriorityLabels.medium(),
  high: PriorityLabels.high(),
};

export const renderPriorityBars = {
  low: PriorityBars.low(),
  medium: PriorityBars.medium(),
  high: PriorityBars.high(),
};

export const getPrioriyLabel = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
};

type OptionType = OptionTypeBase & { label: string; value: string };
type GroupType = GroupTypeBase<OptionType>;

export const prioritySelectStyles: StylesConfig<OptionType, boolean, GroupType> = {
  ...userSelectStyles,
  menuPortal: (base) => ({ ...base, zIndex: 1600 }),
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    ...(userSelectStyles?.option
      ? userSelectStyles?.option(styles, {
          isDisabled: isDisabled,
          isFocused: isFocused,
          isSelected: isSelected,
        } as any)
      : {}),

    padding: '1.3rem 1.5rem 1.3rem 1rem',
  }),
};

export const PrioritySelectSingleValue:
  | React.ComponentType<SingleValueProps<OptionType, GroupType>>
  | undefined = (props) => (
  <div className="flex items-center">
    {renderPriorities?.[props.data.value]}
    <span className="ml-8">{props.data.label}</span>
  </div>
);

export const PrioritySelectSingleValueFlag = (props: { data: { value: string } }) => {
  const priority = priorityOptions.find((obj) => obj.value === props.data.value);
  return (
    <div
      className="flex items-center justify-center rounded-full border p-4 text-gray-400"
      style={{ color: priority?.color }}
    >
      <div
        className="rounded-full border p-4 flex items-center"
        style={{ borderColor: 'currentcolor' }}
      >
        <PriorityFlagIcon />
      </div>
    </div>
  );
};

export const PrioritySelectOption: any = (props) => (
  <SelectComponents.Option {...props}>
    <div className="flex items-center">
      {renderPriorities?.[props.data.value]}
      <span className="ml-8">{props.data.label}</span>
    </div>
  </SelectComponents.Option>
);
